var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactsheetBrickGrowth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 25,
    viewBox: "0 0 224 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.386719 1.62109H42.5675C44.3497 1.62109 46.0773 2.23555 47.4593 3.36088L69.8239 21.5728C71.2059 22.6981 72.9335 23.3126 74.7157 23.3126H162.195C164.688 23.3126 167.03 22.1122 168.485 20.0874L179.441 4.84627C180.897 2.82146 183.238 1.62109 185.731 1.62109H223.499",
    stroke: "#7C7272",
    strokeWidth: 2.32409
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactsheetBrickGrowth);
export default __webpack_public_path__ + "static/media/factsheetBrickGrowth.ba0348c3330d29345859d681877a9b40.svg";
export { ForwardRef as ReactComponent };